import React, { useEffect } from 'react';
import { IconButton } from '@material-tailwind/react';
import { X } from 'lucide-react';


const Modal = ({
    isOpen,
    onClose,
    title,
    children,
    maxWidth = 'md', // sm, md, lg, xl, xxl, full
    showCloseButton = true,
}) => {
    // Prevent body scroll when modal is open
    useEffect(() => {
        if (isOpen) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = 'unset';
        }
        return () => {
            document.body.style.overflow = 'unset';
        };
    }, [isOpen]);

    // Handle escape key press
    useEffect(() => {
        const handleEscape = (e) => {
            if (e.key === 'Escape') onClose();
        };

        if (isOpen) {
            document.addEventListener('keydown', handleEscape);
        }

        return () => {
            document.removeEventListener('keydown', handleEscape);
        };
    }, [isOpen, onClose]);

    if (!isOpen) return null;

    const maxWidthClasses = {
        sm: 'max-w-sm',
        md: 'max-w-md',
        lg: 'max-w-lg',
        xl: 'max-w-full md:max-w-[70%]',
        xxl: 'max-w-full lg:max-w-[70%] xl:max-w-[50%]',
        xxxl: 'max-w-full md:max-w-[80%]',
        full: 'max-w-full'
    };

    return (
        <div className="fixed inset-0 overflow-y-auto overflow-x-hidden" style={{ zIndex: 2000 }}>
            {/* Backdrop */}
            <div
                className="fixed inset-0 bg-black bg-opacity-50 transition-opacity"
                onClick={onClose}
            />

            {/* Modal */}
            <div className="flex min-h-screen items-center justify-center p-5">
                <div
                    className={`relative w-full ${maxWidthClasses[maxWidth]} transform rounded-xl bg-white transition-all`}
                    onClick={e => e.stopPropagation()}
                >
                    <div className={`absolute -right-5 -top-5`}>
                        {showCloseButton && (
                            <IconButton className='bg-black text-white rounded-full' onClick={onClose}>
                                <X />
                            </IconButton>
                        )}
                    </div>
                    {/* Header */}
                    {(title || showCloseButton) && (
                        <div className={`px-5 pt-5`}>
                            <div className="flex items-center justify-between w-full">
                                {title && typeof title === 'string' && (
                                    <span className="text-lg font-thin text-gray-900">
                                        {title}
                                    </span>
                                )}
                                {title && typeof title === 'object' && title}

                            </div>
                            <hr className='mt-3' />
                        </div>
                    )}

                    {/* Content */}
                    <div className="px-5 py-4">
                        {children}
                    </div>
                </div>

            </div>
        </div>
    );
};

export default Modal;